import SvgIcon from '@/components/shared/SvgIcon'

const req = require.context('@/assets/icons/svg/', false, /\.svg$/)
const requireAll = requireContext => requireContext.keys().map(requireContext)
requireAll(req)

export default {
  install (Vue) {
    // register globally
    Vue.component('svg-icon', SvgIcon)
  }
}
